const { isEmpty } = require('lodash');

const settingsFields = () => {
  return {
    fiscalYearEnd: {
      type: 'select',
      label: '決算月',
      options: Array.from({ length: 12 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}月`
      })),
      initialValue: 12,
      validations: {
        required: v => v != null,
      },
    },
    costingMethod: {
      type: 'select',
      label: '原価計算方法',
      options: [
        {
          value: 'latestCost',
          label: '最終仕入原価法'
        },
        // {
        //   value: 'movingAverage',
        //   label: '移動平均法'
        // },
      ],
      initialValue: 'latestCost',
      validations: {
        required: v => v != null,
      },
    },
    exportExcludeTax: {
      type: 'select',
      label: '税抜き表示のデフォルト',
      options: [
        {
          value: 'included',
          label: '税込'
        },
        {
          value: 'excluded',
          label: '税抜き'
        },
      ],
      initialValue: 'included',
      validations: {
        required: v => v != null,
      },
    },
  };
};

exports.settingsFields = settingsFields;
